const MODAL_COUNT_ATTR = 'modal-count'

function getPageScroller(): Element {
  const { body, scrollingElement } = document

  if (scrollingElement && scrollingElement.scrollHeight > scrollingElement.clientHeight + 1) {
    return scrollingElement
  }

  if (body.scrollHeight > body.clientHeight + 1) {
    return body
  }

  return scrollingElement || body
}

function scrollInstantly(el: Element, top: number) {
  el.scrollTo({ top, behavior: 'instant' })
}

export function preventScroll() {
  if (!document.body.classList.contains('hide-overflow')) {
    const appEl = document.getElementById('app')
    if (appEl && document.scrollingElement) {
      const scrollbarWidth = Math.min(32, window.innerWidth - appEl.clientWidth)
      const { scrollTop } = getPageScroller()
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`
      }
      document.body.classList.add('hide-overflow')
      document.body.setAttribute(MODAL_COUNT_ATTR, '1')
      scrollInstantly(document.body, scrollTop)
    }
  } else {
    const count = document.body.getAttribute(MODAL_COUNT_ATTR)
    document.body.setAttribute(MODAL_COUNT_ATTR, `${parseInt(count || '0', 10) + 1}`)
  }
}

export function allowScroll() {
  if (document.body.classList.contains('hide-overflow')) {
    const count = parseInt(document.body.getAttribute(MODAL_COUNT_ATTR) || '1', 10)
    if (count <= 1) {
      document.body.removeAttribute(MODAL_COUNT_ATTR)
      const { scrollTop } = document.body
      document.body.classList.remove('hide-overflow')
      document.body.style.paddingRight = ''

      const scroller = getPageScroller()
      scrollInstantly(scroller, scrollTop)
      if (scroller !== document.body) {
        scrollInstantly(document.body, 0)
      }
    } else {
      document.body.setAttribute(MODAL_COUNT_ATTR, `${count - 1}`)
    }
  }
}
